const REDIRECT_PATH_STORAGE_KEY = "km_redirect_path";

export const saveRedirectPath = (redirectPath: string) => {
    try {
        window.sessionStorage.setItem(REDIRECT_PATH_STORAGE_KEY, redirectPath);
    } catch {
        return;
    }
};

export const readRedirectPath = (): string | null => {
    try {
        return window.sessionStorage.getItem(REDIRECT_PATH_STORAGE_KEY);
    } catch {
        return null;
    }
};

export const clearRedirectPath = () => {
    try {
        window.sessionStorage.removeItem(REDIRECT_PATH_STORAGE_KEY);
    } catch {
        return;
    }
};
const REDIRECT_PATH_STORAGE_KEY = "km_redirect_path";

export const saveRedirectPath = (redirectPath: string) => {
    try {
        window.sessionStorage.setItem(REDIRECT_PATH_STORAGE_KEY, redirectPath);
    } catch {
        return;
    }
};

export const readRedirectPath = (): string | null => {
    try {
        return window.sessionStorage.getItem(REDIRECT_PATH_STORAGE_KEY);
    } catch {
        return null;
    }
};

export const clearRedirectPath = () => {
    try {
        window.sessionStorage.removeItem(REDIRECT_PATH_STORAGE_KEY);
    } catch {
        return;
    }
};
